export const transformKeysToArray = (fieldKeys) => {
  const template_fields_data = fieldKeys.reduce((acc, fd) => {
    const [templateId, key] = fd.split("#");
    acc[templateId] = acc[templateId] || [];
    acc[templateId].push(key);
    return acc;
  }, {});

  return Object.entries(template_fields_data).map(([template_id, fields]) => ({
    template_id,
    fields,
  }));
};

export const getAllFieldsArrayFromEntity = (entity, formatKeys = true) => {
  let keys =  entity?.templates?.flatMap(({ template_id, templateInfo }) => {
    return templateInfo?.sections?.[0].fields?.flatMap(({ key, inputType }) => {
      const baseKey = key?.includes("#") ? key : `${template_id}#${key}`;
      const extraKeys = {
        ENTITY: [`${baseKey}/name`],
        INTEGRATION: [`${baseKey}/name`],
        PHONE_COUNTRY_CODE: [`${baseKey}_code`],
        AUTO_INCREMENT_NUMBER: [`${baseKey}_info`],
        MASKED: [`${baseKey}_masked`],
        PAY_BUTTON: [`${baseKey}_history`,`${baseKey}_info`]
      };
      return [baseKey, ...(extraKeys[inputType] || [])];
    });
  });
  return formatKeys ? transformKeysToArray(keys) : keys;
};

